import ManageParamtersModal from "./ManageParametersModal";
export default ManageParamtersModal;